import type { InternalRequest } from '../client.js';
import type { User } from '@trackizy/types';

type Params = Record<string, string | number | boolean | undefined | null>;

function qsFrom(params?: Params): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== '');
  if (!entries.length) return '';
  const usp = new URLSearchParams();
  for (const [k, v] of entries) usp.set(k, String(v));
  return `?${usp}`;
}

export function usersEndpoints(req: InternalRequest) {
  return {
    list: (params?: Params) => req.request<User[]>(`/users${qsFrom(params)}`),
    get: (id: string) => req.request<User>(`/users/${id}`),
    create: (data: Partial<User> & { password?: string }) =>
      req.request<User>('/users', { method: 'POST', body: JSON.stringify(data) }),
    update: (id: string, data: Partial<User> & { password?: string }) =>
      req.request<User>(`/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id: string) => req.request<void>(`/users/${id}`, { method: 'DELETE' }),
    /** Saved views / pinned vehicles / dashboard layout. */
    preferences: {
      get: (key: string) =>
        req.request<{ value: unknown }>(`/user-preferences/${encodeURIComponent(key)}`),
      set: (key: string, value: unknown) =>
        req.request<unknown>(`/user-preferences/${encodeURIComponent(key)}`, {
          method: 'PUT',
          body: JSON.stringify({ value }),
        }),
    },
    /** Push notification tokens for mobile app. */
    pushTokens: {
      register: (body: { token: string; platform: 'ios' | 'android'; app: 'fleet' | 'staff'; deviceName?: string; appVersion?: string }) =>
        req.request<{ id: string; user_id: string; token: string; platform: 'ios' | 'android'; app: 'fleet' | 'staff'; created_at: string; last_seen_at: string; invalidated_at: string | null }>(
          '/users/me/push-tokens',
          { method: 'POST', body: JSON.stringify(body) },
        ),
      unregister: (token: string) =>
        req.request<null>(`/users/me/push-tokens/${encodeURIComponent(token)}`, { method: 'DELETE' }),
    },
  };
}
